import { useSnapshot } from "valtio";
import { bookingsStore, configStore, dataListStore } from "../state/CommonState";
import { useEffect, useState } from "react";
import Api from "../state/Api";
import { useFieldArray, useForm } from "react-hook-form";
import Utils from "../util/Utils";
import LabeledSelectField from "../mui-components/LabeledSelectField";
import LabeledTextField from "../mui-components/LabeledTextField";
import { loader } from "../util/loader";
import RoleUtils from "../util/RoleUtils";
import { PERMISSIONS_NEW } from "../util/constants";
import BookingsApi from "../state/bookings-api";

export function ShippingDetailsForm() {
    useSnapshot(bookingsStore)
    useSnapshot(dataListStore)
    const [disableFields, setDisableFields] = useState(true)
    const textFieldStyle = {
        fontSize: "14px",
        color: process.env.REACT_APP_ENTERPRISE_COLOUR,
        fontWeight: "bold",
    }
    const booking = bookingsStore.current

    useEffect(() => {
        if(RoleUtils.isUserAuthorized(PERMISSIONS_NEW.BOOKINGS.EDIT_SHIPPING_DETAILS)){
            setDisableFields(false)
        }
        Api.getMasterJobDropdown()
    }, []);

    const { register, control, handleSubmit, setValue, watch } = useForm({
        defaultValues: {
            haz: booking.contract.hazardous,
            stackables: booking.contract.nonStackable,
            refrigeration: 'No',
            commodityGroup: booking?.shippingDetails?.commodityGroup ? booking?.shippingDetails?.commodityGroup:'',
            description: booking?.shippingDetails?.description ? booking?.shippingDetails?.description : '',
            externalPack: booking.contract.cargoList.length > 1 ? 'Packages' : booking.contract.cargoList[0]?.packageType,
            internalPack: booking.contract.cargoList.length > 1 ? 'Packages' : booking.contract.cargoList[0]?.packageType,
            noOfPieces: booking.contract.cargoTotals.totNumPackages,
            marksAndNumbers: booking?.shippingDetails?.marksAndNumbers ? booking?.shippingDetails?.marksAndNumbers:'',
            grossWeightKg: booking.contract.cargoTotals.totTotalWeight,
            grossWeightLBS: Utils.toUnit(parseFloat(booking.contract.cargoTotals.totTotalWeight || 0), 'Lbs'),
            volume: booking.contract.cargoTotals.totTotalVolume,
            chargeableVolume: booking.contract.cargoTotals.totChargeableWeight,
            serviceCode: booking?.shippingDetails?.serviceCode ? booking?.shippingDetails?.serviceCode :'',
            cargoType: booking?.shippingDetails?.cargoType ? booking?.shippingDetails?.cargoType :'',
            natureOfCargo:"",
            cargoMovement:"",
            hblType:"",
            hblDate:"",
            manifestHblNo:"",
            itemNo:"",
            subItemNo:"",
            extCargoReadyDate:"",
            actualCargoReadyDate:"",
            actualCargoReceivedDate:"",
            dimensions: booking.contract.cargoList.map((e) => ({
                pieces: e.numPackages || "",
                length: e.length || "",
                width: e.width || "",
                height: e.height || "",
                volume: e.totalVolume || "",
                weight: e.totalWeight || ""
            }))
        }
    });

    useEffect(() => {
        BookingsApi.getBooking(bookingsStore.current._id, (data) => {
          if(data?.shippingDetails){
            [
              "haz",
              "stackables",
              "refrigeration",
              "commodityGroup",
              "description",
              "externalPack",
              "internalPack",
              "noOfPieces",
              "marksAndNumbers",
              "grossWeightKg",
              "grossWeightLBS",
              "volume",
              "chargeableVolume",
              "serviceCode",
              "cargoType",
              "natureOfCargo",
              "cargoMovement",
              "hblType",
              "hblDate",
              "manifestHblNo",
              "itemNo",
              "subItemNo",
              "extCargoReadyDate",
              "actualCargoReadyDate",
              "actualCargoReceivedDate"
            ].forEach((key) => {
              setValue(key, data.shippingDetails[key] || "")
            })

            if(data.shippingDetails.dimensions && data.shippingDetails.dimensions.length > 0){
                data.shippingDetails.dimensions.forEach((dimension, index) => {
                    ["pieces", "length", "width", "height", "volume", "weight"].forEach((key) => {
                        setValue(`dimensions.${index}.${key}`, dimension[key] || "")
                    })
                })
            }
        }
        })
    },[])

    const { fields, append } = useFieldArray({
        control,
        name: "dimensions"
    });

    const packageTypeList = ['Packages', 'Pallet', 'Drum', 'Crate', 'Skid', 'Loose Cartons', 'Box', 'Bales', 'Rolls']
    const natureOfCargoList = ['Containerized(C)', 'Dry Bulk(DB)', 'Liquid Bulk(LB)', 'Non Containerized package(P)','Partly Containerized(CP)']
    const cargoMovementList = ['Bhutan Cargo(BT)', 'Dry Bulk(DB)', 'Government Cargo(GC)', 'International Transhipment(ITP)', 'Local Cargo(LC)', 'Nepal Cargo(TC)', 'Transhipment Cargo - ICD(SMTP)','Transhipment Cargo - Non ICD(TP)']
    const hblTypeList = ['RFS', 'SEAWAY B/L', 'Telex release B/L', 'Original B/L', 'Carrier B/L', 'Surrender B/L','Express B/L']
    const onSave = (data) => {
        console.log(data, "data while submitting");
        const payload = {
            id: bookingsStore.current._id,
            type: "shippingDetails",
            data: data
        }
        console.log(payload, "hgvfgvygyerjfr");
        loader.show()
        Api.updateShippingDetails(payload, (data) => {
            bookingsStore.current = data
            loader.hide()
            configStore.setModalMessage('Shipping Details Updated Successfully')
            configStore.shippingDetails = false 
        })
    };
    const additionalInformationList = [
        { label: "Nature of Cargo", name: "natureOfCargo" },
        { label: "Cargo Movement", name: "cargoMovement" },
        { label: "HBL Type", name: "hblType" },
        { label: "HBL Date", name: "hblDate", type: 'date' },
        { label: "Manifest HBL No", name: "manifestHblNo", type: 'text' },
        { label: "Item No", name: "itemNo", type: 'text' },
        { label: "Sub Item No", name: "subItemNo", type: 'text', },
        { label: "Ext Cargo Ready Date", name: "extCargoReadyDate", type: 'date', },
        { label: "Actual Cargo Ready Date", name: "actualCargoReadyDate", type: 'date', },
        { label: "Actual Cargo Received Date", name: "actualCargoReceivedDate", type: 'date', },

    ]
    return (
        <div style={{ borderRadius: "6px", boxShadow: "0 4px 10px rgba(0,0,0,0.1)", position: "fixed", inset: 0, top: "50px", zIndex: 1000, display: "flex", flexDirection: "column", overflowY: "auto" }} className="flex flex-col w-full rounded-md bg-white shadow-custom p-[18px] gap-[18px] mt-[5px]">
            <div style={{ borderRadius: "6px", boxShadow: "0 4px 10px rgba(0,0,0,0.1)", padding: '18px' }}>
                <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                    <h4 className="title">Shipping Details</h4>
                    <button style={{ float: 'right' }} className="button is-small islink"
                        onClick={async (e) => {
                            configStore.shippingDetails = false
                        }}>
                        <span className="icon ">
                            <i className="fas fa-xmark"></i>
                        </span>
                    </button>
                </div>
                <form onSubmit={handleSubmit(onSave)} style={{ padding: "20px" }}>
                    <div
                        style={{
                            display: "flex",
                            gap: "30px",
                            marginBottom: "20px",
                            justifyContent: 'space-between',
                            flexWrap: "wrap"
                        }}
                    >
                        {[{ key: "haz", label: "HAZ" }, { key: "stackables", label: "Stackables" }, { key: "refrigeration", label: "Refrigeration Required" }].map((field) => (
                            <div
                                key={field.key}
                                style={{
                                    display: "flex",
                                    flexDirection: "column",
                                    gap: "6px",
                                    width: "160px"
                                }}
                            >
                                <label
                                    style={{
                                        fontSize: "14px",
                                        fontWeight: "bold",
                                        color: process.env.REACT_APP_ENTERPRISE_COLOUR
                                    }}
                                >
                                    {field.label}
                                </label>

                                <div
                                    style={{
                                        display: "flex",
                                        border: "1px solid #EBEBEB",
                                        borderRadius: "6px",
                                        overflow: "hidden",
                                        background: "white"
                                    }}
                                >
                                    {["Yes", "No"].map((option) => {
                                        const isActive = watch(field.key) === option;

                                        return (
                                            <button
                                                key={option}
                                                disabled={true}
                                                type="button"
                                                style={{
                                                    flex: 1,
                                                    border: "none",
                                                    background: isActive ? "#F0903C" : "white",
                                                    color: isActive ? "white" : "#333",
                                                    padding: "10px 5px",
                                                    fontSize: "14px",
                                                    cursor: "pointer"
                                                }}
                                                onClick={() => setValue(field.key, option)}
                                            >
                                                {option}
                                            </button>
                                        );
                                    })}
                                </div>
                            </div>
                        ))}
                    </div>
                    <div style={{ display: 'flex', gap: '10px' }}>
                        <LabeledSelectField labelStyle={{
                            fontSize: "14px",
                            color: process.env.REACT_APP_ENTERPRISE_COLOUR,
                            fontWeight: "bold",
                            marginBottom: '5px'
                        }} control={control} options={dataListStore.MasterJobDropownList.length > 0 && dataListStore['MasterJobDropownList'].filter(e => e.type === 'ServiceCode').map(e => e.serviceCode) || []} name={'serviceCode'} label={'Service Code'} fullwidth={true} />
                        <LabeledSelectField labelStyle={{
                            fontSize: "14px",
                            color: process.env.REACT_APP_ENTERPRISE_COLOUR,
                            fontWeight: "bold",
                            marginBottom: '5px'
                        }} control={control} options={dataListStore.MasterJobDropownList.length > 0 && dataListStore['MasterJobDropownList'].filter(e => e.type === 'CargoType').map(e => e.cargotype) || []} name={'cargoType'} label={'Cargo Type'} fullwidth={true} />
                    </div>

                    {/* Commodity Description */}
                    <div style={{ marginBottom: "25px" }}>
                        <div style={{ marginBottom: "6px", color: '#2B3688' }}>Commodity Description</div>
                        <textarea
                            {...register("description")}
                            style={{ width: "100%", height: "80px", padding: "8px" }}
                        />
                    </div>

                    {/* Pack & Dimension */}
                    <p style={{ fontWeight: 600, fontSize: '18px' }}>Pack & Dimension Information</p>

                    <div style={{ display: "flex", gap: "15px",flexWrap:'wrap', marginBottom: "10px", marginTop: "20px" }}>
                        {[
                            { label: "External Pack", name: "externalPack"},
                            { label: "Internal Pack", name: "internalPack" },
                            { label: "Number of Pieces", name: "noOfPieces", type: 'number',disabled:disableFields },
                            { label: "Gross Weight(Kg)", name: "grossWeightKg", type: 'number', disabled: disableFields },
                            { label: "Gross Weight(LBS)", name: "grossWeightLBS", type: 'number', disabled: disableFields },
                            { label: "Volume(CBM)", name: "volume", type: 'number', disabled: disableFields },
                            // { label: "Chargeable Volume", name: "chargeableVolume", type: 'number', disabled: disableFields },
                        ].map((field) => (
                             <div
                            key={field.name}
                            style={{
                                flex: "0 1 calc(25% - 16px)",
                                minWidth: 250,
                            }}
                        >
                            {(field.label == 'External Pack' || field.label =='Internal Pack')?
                                    <LabeledSelectField
                                        labelStyle={{
                                            fontSize: "14px",
                                            color: process.env.REACT_APP_ENTERPRISE_COLOUR,
                                            fontWeight: "bold",
                                            marginBottom: "5px"
                                        }}
                                        control={control}
                                        options={field.label == 'External Pack' ?[...packageTypeList,'Cartons'] : packageTypeList}
                                        name={field.name}
                                        disabled={field.disabled}
                                        label={field.label}
                                        fullwidth={true}
                                    /> :
                            <LabeledTextField
                            labelStyle={textFieldStyle}
                            label={field.label}
                            control={control}
                            name={field.name}
                            type={'number'}
                            size="small"
                            madatory={true}
                            disabled={disableFields}
                        />
                        }
                        </div>
                    ))}
                    </div>

                    {bookingsStore.current.contract?.finalPlaceOfDelivery?.toLowerCase()?.includes('india') && <>
                        <p style={{ fontWeight: 600, fontSize: '18px' }}>Additional Information</p>

                    <div style={{ display: "flex", gap: "15px",flexWrap:'wrap', marginBottom: "10px", marginTop: "20px" }}>
                        {additionalInformationList?.map((field) => (
                             <div
                            key={field.name}
                            style={{
                                flex: "0 1 calc(25% - 16px)",
                                minWidth: 250,
                            }}
                        >
                                {(field.label == 'Nature of Cargo' || field.label == 'Cargo Movement' || field.label == 'HBL Type')?
                                    <LabeledSelectField
                                        labelStyle={{
                                            fontSize: "14px",
                                            color: process.env.REACT_APP_ENTERPRISE_COLOUR,
                                            fontWeight: "bold",
                                            marginBottom: "5px"
                                        }}
                                        control={control}
                                        options={field.label == 'Nature of Cargo' ? natureOfCargoList : field.label == 'Cargo Movement' ? cargoMovementList : hblTypeList}
                                        name={field.name}
                                        disabled={disableFields}
                                        label={field.label}
                                        fullwidth={true}
                                    /> :
                            <LabeledTextField
                            labelStyle={textFieldStyle}
                            label={field.label}
                            control={control}
                            name={field.name}
                            type={field.type}
                            size="small"
                            disabled={disableFields}
                        />
                        }
                        </div>
                    ))}
                    </div>
                    </>}

                    <div style={{ marginBottom: "25px" }}>
                        <div style={{ marginBottom: "6px", color: '#2B3688' }}>Marks & Numbers</div>
                        <textarea
                            {...register("marksAndNumbers")}
                            style={{ width: "100%", height: "80px", padding: "8px" }}
                        />
                    </div>

                    {
                        bookingsStore.current.contract.shipmentType == 'LCL' && bookingsStore.current.contract.shipmentScope.includes('Door') &&
                        <><p style={{ fontWeight: 600, fontSize: '18px' }}>Dimension Details</p>

                            {fields.map((item, index) => (
                                <div key={item.id} style={{ display: "flex", gap: "10px", marginBottom: "10px", marginTop: '20px' }}>
                                    <div
                                        key={item.id}
                                        style={{
                                            display: "flex",
                                            gap: 16,
                                            marginBottom: 12,
                                            padding: 12,
                                        }}
                                    >
                                        {[
                                            { label: "Number of Pieces", name: "pieces", mandatory: true },
                                            { label: "Length(cm)", name: "length", mandatory: true },
                                            { label: "Width(cm)", name: "width", mandatory: true },
                                            { label: "Height(cm)", name: "height", mandatory: true },
                                            { label: "Volume(CBM)", name: "volume", mandatory: true },
                                            { label: "Gross Weight(Kg)", name: "weight" },
                                        ].map((field) => (
                                            <div
                                                key={field.name}
                                                style={{
                                                    flex: "0 1 calc(25% - 16px)",
                                                    minWidth: 150,
                                                }}
                                            >
                                                <LabeledTextField
                                                    labelStyle={textFieldStyle}
                                                    label={field.label}
                                                    madatory={field.mandatory}
                                                    control={control}
                                                    name={`dimensions.${index}.${field.name}`}
                                                    size="small"
                                                    disabled={disableFields}
                                                />
                                            </div>
                                        ))}
                                        {/* {index != 0 ? <div style={{ marginTop: '35px' }}>
                                <button type="button" style={{ borderRadius: '4px', border: '1px solid' }}
                                    className="button"><img src={deleteicon} /></button>
                        </div> : <div className="w-[35px] mt-[30px] h-full flex items-center justify-center"></div>} */}
                                    </div>
                                    {/* <div style={{ marginTop: '35px' }}>
                                    <button
                                        type="button"
                                        className="button"
                                        style={{ borderRadius: '4px', border: '1px solid #2B3688' }}
                                        onClick={() =>
                                            append({
                                                pieces: "",
                                                length: "",
                                                width: "",
                                                height: "",
                                                volume: "",
                                                weight: ""
                                            })
                                        }
                                    >
                                        +
                                    </button>
                                </div> */}

                                </div>

                            ))}</>
                    }


                    <div style={{ display: "flex", gap: "10px", justifyContent: 'flex-end', marginTop: '15px' }}>
                        {/* <button style={{ border: '1px solid #DB4747', color:'#DB4747', backgroundColor:'#FEE7E7'}}
                    className="button">Cancel</button> */}
                        <button style={{ backgroundColor: '#2B3688', color: '#FFFFFF' }} onClick={handleSubmit(onSave)}
                            className="button">Save</button>
                    </div>

                </form>
            </div>
        </div>
    );
}